import InviteRoute from '@/screens/Join/InviteRoute';

export default function TeamInviteRoute() {
  return <InviteRoute kind="team" />;
}
